import Button from './Button';

function ProjectWrapper(props) {
    return (
        <div className="project-wrapper">
           <div className="project-image-wrapper">
                <img src={props.source} loading='lazy' />
           </div>
           <div className="project-content">
                <div className="project-infos">
                    <h6>{props.title}</h6>
                    <h7>{props.type}</h7>
                    <div className="separator"></div>
                    <p>{props.desc}</p>
                </div>
                <div className="project-link">
                    <Button key={props.title} link={props.link} label="Go To project" />
                </div>
           </div>
        </div>
    )
}

export default ProjectWrapper;